type TProps = {
  label: string;
  displayText: string;
  extraClasses?: string;
};

const FixedSelectDisplay = ({ label, displayText, extraClasses = '' }: TProps) => {
  return (
    <>
      <div className={`fo-fixed-select-display bg-light-grey-500 fo-border-bottom-sm border-grey-200 ${extraClasses}`}>
        <div className="text-2 -regular">{label}</div>
        <div className="text-2 -medium">{displayText}</div>
      </div>
    </>
  );
};

export default FixedSelectDisplay;
